import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SiaChoice, SiaChoiceItem } from '../../interfaces/sia-choice';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';
import { SiaI18nService } from '../../services/i18n.service';

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: `sia-choice-dialog.html`,
  styleUrls: ['sia-choice-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatButton,
    MatIconModule,
    MatDialogClose,
    MatIconButton,
    SiaTranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaChoiceDialogComponent {
  data = inject<SiaChoice>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<SiaChoiceDialogComponent>>(MatDialogRef);
  private i18nService = inject(SiaI18nService);

  choices = signal<SiaChoice>(this.data);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.updateSize('min(95% , 600px)');
    dialogRef.disableClose = true;
    // console.log('SiaChoiceDialogComponent - ', this.choices);
  }

  translate(text: string) {
    return this.i18nService.translate(text);
  }

  choiceClick(item: SiaChoiceItem | null) {
    // console.log('choiceClick', item);
    if (item?.navigationScript) {
      this.dialogRef.close(item.navigationScript);
      return;
    } else if (item?.navigationMenu) {
      this.dialogRef.close(item.navigationMenu);
      return;
    } else {
      this.dialogRef.close(null);
      return;
    }
  }
}
